
/**
 * @file Signup index
 * @author Denny K. Schuldt
 * @copyright Copyright 2017, Datilmedia S.A.
 */

import React from 'react';
import thunk from 'redux-thunk';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';

import reducers from './reducers';
import * as actions from './actions';
import Main from './containers/main';


const middleware = [ thunk ];

const store = createStore(
  reducers,
  applyMiddleware(...middleware)
);


module.exports = (element, data) => {

  window.signup = {};
  window.signup.store = store;
  window.signup.actions = actions;

  let params = window.getUrlParams();
  if (params['error'] && params['error'].length) {
    store.dispatch(actions.updateError( params ))
  }
  if (params['src'] && params['src'].length) {
    store.dispatch(actions.changeSrc({ src: params['src'] }))
  }
  if (params['referido'] && params['referido'].length) {
    store.dispatch(actions.changePromo({ promo: params['referido'] }))
  }
  if (params['aliado'] && params['aliado'].length) {
    store.dispatch(actions.changePromo({ promo: params['aliado'] }))
  }
  if (params['promo'] && params['promo'].length) {
    store.dispatch(actions.changePromo({ promo: params['promo'] }))
  }
  if (params['plan_fee'] && params['plan_fee'].length) {
    store.dispatch(actions.changePlanFee({ planFee: params['plan_fee'] }))
  }
  if (params['plan_code'] && params['plan_code'].length) {
    store.dispatch(actions.changePlanCode({ planCode: params['plan_code'] }))
  }
  if (params['referral_code'] && params['referral_code'].length){
    store.dispatch(actions.setReferralCode({ referral_code : params['referral_code'] }))
  }
  ReactDOM.render(
    <Provider store={store}>
      <Main
        signupUrl={data.signupUrl}
        isUsernameAvailableUrl={data.isUsernameAvailableUrl}
        isEmailAvailableUrl={data.isEmailAvailableUrl}/>
    </Provider>,
    element
  );
}
